"use client";

import {
    Stepper,
    StepperDescription,
    StepperIndicator,
    StepperItem,
    StepperSeparator,
    StepperTitle,
    StepperTrigger,
} from "@/components/ui/stepper";

export default function Steper({ steps, activeStep }: { activeStep: number , steps: {step: number, title: string, description: string}[]}) {
    return (
        <div className="space-y-8 text-center w-full">
            <Stepper defaultValue={activeStep}>
                {steps.map(({ step, title, description }) => (
                    <StepperItem
                        key={step}
                        step={step}
                        completed={step < activeStep}
                        className="max-md:items-start [&:not(:last-child)]:flex-1"
                    >
                        <div className="gap-4 inline-flex items-center disabled:pointer-events-none disabled:opacity-50 max-md:flex-col">
                            <StepperIndicator />
                            <div className="text-center md:-order-1 md:text-start">
                                <StepperTitle>{title}</StepperTitle>
                                <StepperDescription className="max-sm:hidden">{description}</StepperDescription>
                            </div>
                        </div>
                        {step < steps.length && <StepperSeparator className="max-md:mt-3.5 md:mx-4" />}
                    </StepperItem>
                ))}
            </Stepper>
        </div>
    );
}
